import { render } from "./SectionsIcon.vue?vue&type=template&id=6318f4c9&scoped=true"
import script from "./SectionsIcon.vue?vue&type=script&lang=js"
export * from "./SectionsIcon.vue?vue&type=script&lang=js"

import "./SectionsIcon.vue?vue&type=style&index=0&id=6318f4c9&scoped=true&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6318f4c9"]])

export default __exports__